import React from "react";
import get from "lodash/get";
import { object } from "prop-types";
import { collectionToStories } from "@quintype/components";
import ImageType2 from "../../../../components/molecules/image-type-2";
import ImageType1 from "../../../../components/molecules/image-type-1";
import { SectionName } from "../../../../components/molecules/section-name";
import "./color-theme-layout.m.css";

const ColorThemeLayout = ({ collection }) => {
  const showSection = get(collection, ["associated-metadata", "show-section-title"], true); //default should be false
  const storiesFromCollection = collectionToStories(collection);
  if (storiesFromCollection.length < 1) {
    return null;
  }
  const [firstStory, ...remainingStories] = storiesFromCollection || [];
  return (
    <React.Fragment>
      <div styleName="wrapper color-theme">
        <div styleName="container">
          <div styleName="inner-container">
            {showSection && (
              <div>
                <SectionName collection={collection} />
              </div>
            )}
            <div styleName="big-img">
              <ImageType1 story={firstStory} showSubHeadline={false} />
            </div>
            <div styleName="small-img-wrapper">
              {remainingStories.length >= 1 &&
                remainingStories.slice(0, 3).map((item, index) => (
                  <React.Fragment key={index}>
                    <div styleName="item" key={item.id}>
                      <ImageType2 story={item} showSubHeadline={false} />
                    </div>
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ColorThemeLayout.propTypes = {
  collection: object,
};

export { ColorThemeLayout };
